
const m = window.require("embercom/lib/inbox/requests");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
